export const cartState = state => {
  return { 
    cart: state.cart
  };
};